<template>
    <div class="listing_box">
        <div class="listing_title" v-if="list!=null">
            <div class="listing_title_host">{{ list.title }}</div>
            <div class="listing_title_assistant">{{ list.createTime }}</div>
        </div>
        <!--内容区域 -->
        <div class="content" v-if="list!=null">
            <div v-if="list.contentType==2" class="video_box">
                <video  class="video" controls loop autoplay>
                        <source  :src="basevideo+list.content">
                </video>
            </div>
            <div v-if="list.contentType==1" class="text_box" v-html="list.content"></div>
        </div>
    </div>
</template>
<script>
import basevideo from '../../utils/video'
export default {
    data(){
        return{
            scope:null,
            basevideo,
            list:null,
        }
    },
    created(){
        this.list=JSON.parse( sessionStorage.getItem('listing'))
    },
    methods:{
       
    }
}
</script>
<style lang="less" scoped>
.listing_box{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .listing_title{
        width: 60%;
        border-bottom:1px solid #E3E3E3 ;
        height: 100px;
        margin-bottom: 10px;
        .listing_title_host{
            
            font-size: 36px;
        }
        .listing_title_assistant{
            font-size: 18px;
            color: #606060; 
            margin-top: 10px;            
        }
    }
    .content{
        display: flex;
        justify-content: center;
        .text_box{
            width: 60%;
            margin-bottom: 20px;
        }
        .video_box{
            margin-bottom: 20px;
            .video{
                width: 1280px;
                height: 720px;
                box-sizing: border-box;
            }
        }
    }
}
</style>